<template>
  <v-layout
      d-flex
      row
      :class="{
            'mb-5': !isBusinessPlus,
            'study-block-component': $vuetify.breakpoint.mdAndUp,
            shadowed: $vuetify.breakpoint.smAndDown,
            'mx-4': $vuetify.breakpoint.sm,
            'mx-0': $vuetify.breakpoint.xs
        }"
  >
    <v-flex
        v-if="$vuetify.breakpoint.mdAndUp && !isBusinessPlus"
        md4
        column
        class="study-block study-block-small pa-4"
        :class="[
                card.mandatory ? 'study-block-required' : 'study-block-not-required'
            ]"
    >
      <div class="labels">
        <labelTopic :class="classes">
          {{ $t(card.filter.label_text) }}
        </labelTopic>
      </div>
      <v-layout align-center justify-center column>
        <div
            class="study-circle"
            :class="{ 'study-circle--grey': !card.mandatory }"
        >
          <svg
              v-svg
              :symbol="card.filter.card_image"
              size="133 128"
              class="study__icon-big mt-5"
          />
        </div>
        <div
            class="section-label section-label--mandatory"
            :class="[
                        card.mandatory ? 'section-label--required' : 'section-label--grey'
                    ]"
            v-text="
                        card.mandatory ? $t('Обязательный курс') : $t('Необязательный курс')
                    "
        ></div>
        <div
            v-if="card.mandatory && card.type === 'current'"
            class="study__time-left
                         mt-4"
        >
          <svg
              v-svg
              symbol="hourglass"
              size="93 88"
              class="study__icon"
              role="presentation"
          />
          <span class="text-uppercase">{{ $t(show_rest_time) }}</span>
        </div>
        <v-layout
            v-if="card.mandatory && card.type === 'finished'"
            class="study__time-left
                         mt-4"
        >
          <template
              v-if="
                            card.points_required_test > 0 &&
                                card.points_earned_test >= card.points_required_test
                        "
          >
            <v-flex>
              <svg
                  v-svg
                  symbol="completed"
                  size="16"
                  class="study__icon"
                  role="presentation"
              />
            </v-flex>
            <v-flex class="text-uppercase">
              {{ $t("тест успешно сдан") }} <br>
              {{ card.completed_date }}
            </v-flex>
          </template>
          <template v-else-if="card.points_required_test > 0">
            <v-flex class="text-uppercase">
              {{ $t("тест не сдан") }}
            </v-flex>
          </template>
        </v-layout>
      </v-layout>
    </v-flex>

    <v-flex v-if="$vuetify.breakpoint.smAndDown" column px-4>
      <div class="labels">
        <labelTopic :class="classes">
          {{ $t(card.filter.label_text) }}
        </labelTopic>
        <div
            class="section-label"
            :class="[
                        card.mandatory ? 'section-label--required' : 'section-label--grey'
                    ]"
            v-text="
                        card.mandatory ? $t('Обязательный курс') : $t('Необязательный курс')
                    "
        ></div>
      </div>
      <div class="title my-3">
        {{ $t(card.title) }}
      </div>
      <div
          v-if="card.mandatory && card.type === 'current'"
          class="study__time-left
                         mt-4 mb-2 red-text text-uppercase"
      >
        <svg
            v-svg
            symbol="hourglass"
            size="93 88"
            class="study__icon"
            role="presentation"
        />
        <span class="text-uppercase">{{ show_rest_time }}</span>
      </div>
      <v-layout
          v-if="card.mandatory && card.type === 'finished'"
          class="study__time-left
                         mt-4"
      >
        <template
            v-if="
                        card.points_required_test > 0 &&
                            card.points_earned_test >= card.points_required_test
                    "
        >
          <v-flex>
            <svg
                v-svg
                symbol="completed"
                size="16"
                class="study__icon"
                role="presentation"
            />
          </v-flex>
          <v-flex class="text-uppercase">
            {{ $t("тест успешно сдан") }} <br>

            {{ card.completed_date }}
          </v-flex>
        </template>
        <template v-else-if="card.points_required_test > 0">
          <v-flex class="text-uppercase">
            {{ $t("тест не сдан") }}
          </v-flex>
        </template>
      </v-layout>
      <v-layout
          v-if="card.mandatory && card.type !== 'newcourse'"
          row
          class="mr-4 mb-2"
      >
        <svg
            v-svg
            symbol="schedule"
            class="study__icon study__icon-grey"
            role="presentation"
        />
        <v-flex>{{ card.date_start }} - {{ card.date_end }}</v-flex>
      </v-layout>
      <v-layout v-if="card.series" row>
        <svg
            v-svg
            symbol="series"
            class="study__icon study__icon-grey"
            role="presentation"
        />
        <v-flex>
          <span>{{ $t(card.series) }}</span>
        </v-flex>
      </v-layout>
      <!--            <router-link-->
      <!--                class="link link&#45;&#45;red"-->
      <!--                :to="{-->
      <!--                    name: 'course_content',-->
      <!--                    params: { id: card.id, card_number: card_number }-->
      <!--                }"-->
      <!--            >-->
      <!--                {{ $t("Подробнее о курсе") }}-->
      <!--            </router-link>-->
      <v-flex
          v-if="card.type !== 'finished'"
          md6
          justify-end
          text-md-right
          text-xs-left
          @click="pushToCourse('viewBtn')"
      >
        <a class="link link--red">
          {{ $t("Подробнее о курсе") }}
        </a>
      </v-flex>
      <v-layout justify-space-between align-center row
                wrap mt-4
      >
        <v-flex md3 mb-3>
          <!--                    <router-link-->
          <!--                        :to="{-->
          <!--                            name: 'course_content',-->
          <!--                            params: { id: card.id, card_number: card_number }-->
          <!--                        }"-->
          <!--                        :class="{ layout: $vuetify.breakpoint.xs }"-->
          <!--                    >-->
          <!--                        <buttonRed-->
          <!--                            :disabled="blockCourse"-->
          <!--                            :class="{ 'flex xs12': $vuetify.breakpoint.xs }"-->
          <!--                            v-text="$t(buttonText)"-->
          <!--                        />-->
          <!--                    </router-link>-->
          <div :class="{ layout: $vuetify.breakpoint.xs }" @click="pushToCourse('pushBtn')">
            <buttonRed
                :disabled="blockCourse || disabledByAttempts || disabledByUserStatus"
                :class="{ 'flex xs12': $vuetify.breakpoint.xs }"
                v-text="$t(buttonText)"
            />
          </div>
          <div v-if="blockCourse" class="mt-2">
            {{ $t("Вы начали другой курс") }}
          </div>
          <!--                    <div v-if="card.date_start" class="mt-2">{{$t("Осталось попыток:")}} {{ card.test_attempts }}</div>-->
        </v-flex>
        <v-flex d-flex align-center md9
                mb-3
        >
          <v-flex
              v-if="card.points_required_test > 0 && if_course_completed"
              d-flex
              class="xs3 sm4"
              :class="{
                            'mr-3 ml-1': $vuetify.breakpoint.xs,
                            'mx-3': $vuetify.breakpoint.smAndUp
                        }"
              v-html="
                            $t(
                                'Результат {lineBreak} итогового теста {lineBreak} {points} из {total}',
                                {
                                    lineBreak: '<br>',
                                    points: card.points_earned_test,
                                    total: card.points_total_test
                                }
                            )
                        "
          />
          <v-flex
              v-else
              d-flex
              class="xs3 sm4"
              :class="{
                            'mr-3 ml-1': $vuetify.breakpoint.xs,
                            'mx-3': $vuetify.breakpoint.smAndUp
                        }"
              v-html="lessonsProgressText"
          />
          <v-flex xs8 sm3 md2
                  lg1 mr-2
          >
            <v-progress-circular
                :rotate="-90"
                :size="64"
                :width="6"
                :value="percentCount"
                :color="
                                if_course_completed && percentCount >= 60
                                    ? '#44b69e'
                                    : '#e2173d'
                            "
            >
              {{ percentCount }}%
            </v-progress-circular>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-layout
          v-for="(certificate, coursePassingId) in card.certificate"
          v-if="if_course_completed && Object.keys(card).length"
          :key="coursePassingId"
          d-flex
          class="justify-end"
          column
          mt-2
          mb-3
          wrap
      >
        <v-flex text-xs-left xs12>
          <a class="" @click.prevent="get_certificate_course(coursePassingId)">
            {{ $t("Скачать сертификат о прохождении курса") }}
            <v-icon aria-hidden="true" translate="no">picture_as_pdf</v-icon>
          </a>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex v-if="$vuetify.breakpoint.mdAndUp" column
            class="pa-4"
            :class="{ 'md8': !isBusinessPlus }"
    >
      <v-layout
          d-flex
          row
          wrap
          align-center
          :class="card.mandatory ? 'justify-space-between' : 'justify-end'"
      >
        <v-layout
            v-if="card.mandatory && card.type !== 'newcourse'"
            row
            md3
            class="mr-4"
        >
          <svg
              v-svg
              symbol="schedule"
              class="study__icon study__icon-grey"
              role="presentation"
          />
          <v-flex>{{ card.date_start }} - {{ card.date_end }}</v-flex>
        </v-layout>
        <v-layout v-if="card.series" row>
          <svg
              v-svg
              symbol="series"
              class="study__icon study__icon-grey"
              role="presentation"
          />
          <v-flex>
            <span>{{ $t(card.series) }}</span>
          </v-flex>
        </v-layout>
        <v-flex
            v-if="card.type !== 'finished'"
            md6
            justify-end
            text-md-right
            text-xs-left
            @click="pushToCourse('viewBtn')"
        >
          <a class="link link--red">
            {{ $t("Подробнее о курсе") }}
          </a>
        </v-flex>
      </v-layout>
      <div class="study__title mt-5 mb-5">
        {{ $t(card.title) }}
      </div>

      <div v-if="isBusinessPlus" class="study__price mb-3">
        <div class="section-label section-label--red">
          0 руб.
        </div>
        <span class="study__old-price">{{ $t(card.price) }} руб.</span>
      </div>

      <v-layout
          justify-space-between
          row
          wrap
          class="align-sm-stretch study__info"
      >
        <v-flex>
          <div @click="pushToCourse('pushBtn')">
            <buttonRed :disabled="disabledByAttempts || disabledByUserStatus" v-text=" $t(buttonText)"  />
          </div>
          <div v-if="blockCourse" class="mt-2">
            {{ $t("Вы начали другой курс") }}
          </div>
          <!--                    <div v-if="card.date_start" class="mt-2">{{$t("Осталось попыток:")}} {{ card.test_attempts }}</div>-->
        </v-flex>
        <v-flex d-flex align-start justify-end
                md9
                :class="{'mt-3': isBusinessPlus}"
        >
          <v-flex
              v-for="(certificate, coursePassingId) in card.certificate"
              v-if="if_course_completed && Object.keys(card).length"
              :key="coursePassingId"
              :class="{ 'mt-3': $vuetify.breakpoint.mdAndUp }"
              d-flex
              class="justify-end study-certificate"
          >
            <a
                class=""
                @click.prevent="get_certificate_course(coursePassingId)"
            >
              {{ $t("Скачать сертификат о прохождении курса") }}
              <v-icon aria-hidden="true" translate="no">picture_as_pdf</v-icon>
            </a>
          </v-flex>
          <v-flex
              v-if="card.points_required_test > 0 && if_course_completed"
              d-flex
              :class="{
                            'justify-end mr-3 lg2': !isBusinessPlus,
                            'is-visually-hidden': isBusinessPlus && this.card.type === 'newcourse',
                        }"
              v-html="lessonsProgressText"
          />
          <v-flex
              v-else
              d-flex
              :class="{
                            'justify-end mr-3 lg2': !isBusinessPlus,
                            'is-visually-hidden': isBusinessPlus && this.card.type === 'newcourse',
                        }"
              v-html="lessonsProgressText"
          />
          <v-flex :class="{'md2 lg1 mr-2': !isBusinessPlus, 'is-visually-hidden': isBusinessPlus && this.card.type === 'newcourse',}">
            <v-progress-circular
                :rotate="-90"
                :size="64"
                :width="6"
                :value="percentCount"
                :color="
                                if_course_completed && percentCount >= 60
                                    ? '#44b69e'
                                    : '#e2173d'
                            "
            >
              {{ percentCount }}%
            </v-progress-circular>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red.vue';
import labelTopic from '@/components/ui/labels/label_topic.vue';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name      : 'StudyCard',
  components: {
    buttonRed,
    labelTopic,
  },
  props: {
    id: {
      type    : Number,
      required: true,
    },
    card_number: {
      type: Number,
    },
    isScorm: {
      type: Boolean,
    },
    scormPath: {
      type: String,
    },
    isBusinessPlus: {
      type   : Boolean,
      default: false,
    },
    isDisabled: {
      type   : Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('cards', [
      'cards',
      'get_card_by_id',
      'lessons_passed',
      'lessons_total',
      'points_total_test',
      'points_required_test',
    ]),
    ...mapState('course_info', [
      'started_course_id',
      'interrupt_test',
    ]),
    ...mapState('testing', ['timer']),
    lessonsProgressText() {
      if (this.isScorm || this.isBusinessPlus) {
        return this.$t(
            'Результат итогового тестирования {lineBreak} {lessonsPassed} из {lessonsTotal}',
            {
              lineBreak: '<br>',
              lessonsPassed: Number(this.card.points_earned_test),
              lessonsTotal: Number(this.card.points_total_test)
            }
        );
      } else {
        return this.$t(
            'Пройдено разделов {lineBreak} {lessonsPassed} из {lessonsTotal}',
            {
              lineBreak: '<br>',
              lessonsPassed: Number(this.card.lessons_passed),
              lessonsTotal: Number(this.card.lessons_total)
            }
        );
      }
    },
    disabledByUserStatus() {
      const user = JSON.parse(localStorage.getItem('user'));
      const achievments = user.achievments;
      const access = user.access_catalog;

      if (!this.isBusinessPlus) {
        return false;
      } else if (achievments && this.isScorm && this.isBusinessPlus) {
        if (achievments.name === 'Эксперт') {
          return false;
        } else {
          return true;
        }
      } else if (!achievments && this.isScorm) {
        return true;
      }
    },
    disabledByAttempts() {
      const isFinished = this.card.type === "finished";
      const isOutOfAttempts = this.card.test_attempts === 0;

      let result = false;

      if (isFinished && isOutOfAttempts) {
        result = false;
      } else if (!isFinished && isOutOfAttempts) {
        result = true;
      }

      return result;
    },
    disabledButton() {
      // TODO: раскомментировать после разработки, добавить оповещение для юзера
      // const lostAttempts = this.card.test_attempts === 0 && !this.blockCourse;
      //
      // if (this.isDisabled) {
      //   return true;
      // } else {
      //   return (
      //     (lostAttempts || this.blockCourse) && this.card.type !== 'finished'
      //   );
      // }

      return false;
    },
    blockCourse() {
      let block = false;

      if (this.interrupt_test === false && !!this.timer.course_id) {
        if (parseInt(this.id) !== parseInt(this.timer.course_id)) {
          block = true;
        }
      }

      return block;
    },
    card: function() {
      return this.get_card_by_id(this.id);
    },
    if_course_completed() {
      // if (this.card.lessons_passed == this.card.lessons_total) {
      if (this.card.type == 'finished') {
        return true;
      } else {
        return false;
      }
    },
    classes: function() {
      const obj = {
        newcourse: 'section-label--green',
        finished : 'section-label--grey',
        current  : 'section-label--white',
      };

      return obj[this.card.type];
    },
    ...mapGetters('course_info', [
      'course_completed',
      'lessons_passed',
      'course_name',
    ]),
    buttonText: function() {
      let text = '';
      if (this.card.type === 'current') {
        text = 'Продолжить курс';
      } else if (this.card.type === 'newcourse') {
        text = 'Начать курс';
      } else if (this.card.type === 'finished') {
        if (this.card.test || this.card.points_required_test == 0) {
          text = 'Посмотреть курс';
        } else {
          text = 'Пройти тест';
        }
      }

      return text;
    },
    show_rest_time() {
      if (this.card.course_rest_time.includes('1 день')) {
        return 'Остался ' + this.card.course_rest_time;
      } else if (this.card.course_rest_time === '0 дней') {
        return 'Просрочен';
      } else {
        return 'Осталось ' + this.card.course_rest_time;
      }
    },
    percentCount() {
      let percent;

      if (this.if_course_completed && this.card.points_required_test > 0) {
        percent = this.percent(
            this.card.points_earned_test,
            this.card.points_total_test
        );
      } else {
        percent = this.percent(
            this.card.lessons_passed,
            this.card.lessons_total
        );
      }

      return percent;
    },
    ...mapGetters('course', ['certificate_url']),
  },
  methods: {
    pushToCourse(source) {
      if ((this.disabledByAttempts || this.disabledByUserStatus) && source !== "viewBtn") {
        return;
      }
      const routeParams = {
        name  : 'course_content',
        params: {id: this.card.id, card_number: this.card_number, mandatory: this.card.mandatory},
      };

      if (this.card.is_scorm) {
        routeParams.query = {
          is_scorm        : this.card.is_scorm,
          scorm_path      : this.card.scorm_path,
          title           : this.card.title,
          course_type     : this.card.type,
          is_business_plus: this.card.is_business_plus,
          is_disabled     : this.card.is_disabled,
          is_disabled_by_user_status: this.disabledByUserStatus,
        };
      }
      this.$router.push(routeParams);
    },
    percent: function(required, total) {
      if (Number(total) !== 0) {
        if (required < total) {
          return Math.round((Number(required) / Number(total)) * 100, 0);
        } else {
          return 100;
        }
      }
    },
    async get_certificate_course(course_passing_id) {
      await this.get_certificate(course_passing_id);
      let win = window.open(this.certificate_url.url, '_blank');
      win.focus();
    },
    ...mapActions('course', ['get_certificate']),
  },
};
</script>
